import React, { useEffect, useState } from 'react';
import './style/UserManagementPage.css';
import NavBarAdmin from "./NavBarAdmin";
import { useNavigate } from "react-router-dom"; // ✅ обязательно импортируйте
import config from './config/config';

const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут

function CompaniesManagementPage() {
    const [insurances, setInsurances] = useState([]);
    const [filteredInsurances, setFilteredInsurances] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedTariff, setSelectedTariff] = useState('');
    const [uploading, setUploading] = useState(false);
    const navigate = useNavigate();

    // ✅ Проверка сессии + загрузка данных
    useEffect(() => {
        const checkSession = () => {
            const isAuth = localStorage.getItem('adminAuth');
            const loginTime = localStorage.getItem('loginTime');

            if (isAuth && loginTime) {
                const diff = Date.now() - Number(loginTime);
                if (diff > SESSION_TIMEOUT) {
                    // ⛔ сессия истекла
                    localStorage.removeItem('adminAuth');
                    localStorage.removeItem('loginTime');
                    alert('Сессия истекла, пожалуйста, войдите заново.');
                    navigate('/panel/admin-panel');
                }
            } else {
                // ⛔ если не авторизован
                navigate('/panel/admin-panel');
            }
        };

        checkSession();
        fetchInsurances();

        // ✅ периодическая проверка сессии (каждую минуту)
        const interval = setInterval(checkSession, 60 * 1000);
        return () => clearInterval(interval);
    }, [navigate]);

    // ✅ Получение списка страховых компаний
    const fetchInsurances = async () => {
        try {
            const res = await fetch(`${config.apiUrl2}/api/insurance/insurance-and-tariff`);
            if (!res.ok) throw new Error("Ошибка при получении данных");
            const data = await res.json();
            setInsurances(data);
            setFilteredInsurances(data);
        } catch (err) {
            console.error('Ошибка при получении данных:', err);
        }
    };

    // ✅ Фильтрация
    const handleFilter = () => {
        let result = [...insurances];

        if (selectedCompany) {
            result = result.filter(item =>
                item.insuranceName.toLowerCase().includes(selectedCompany.toLowerCase())
            );
        }

        if (selectedTariff) {
            result = result.filter(item =>
                item.tariff.name.toLowerCase().includes(selectedTariff.toLowerCase())
            );
        }

        setFilteredInsurances(result);
    };

    const handleResetFilter = () => {
        setSelectedCompany('');
        setSelectedTariff('');
        setFilteredInsurances(insurances);
    };

    // ✅ Загрузка Excel
    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);
        setUploading(true);

        try {
            const res = await fetch(`${config.apiUrl2}/api/insurance/import-insurances`, {
                method: 'POST',
                body: formData,
            });

            if (!res.ok) throw new Error('Ошибка загрузки файла');

            alert('Файл успешно загружен');
            fetchInsurances();
        } catch (err) {
            alert('Ошибка загрузки: ' + err.message);
        } finally {
            setUploading(false);
        }
    };

    // ✅ Скачать Excel
    const handleDownload = async () => {
        try {
            const response = await fetch(`${config.apiUrl2}/api/insurance/download-insurance-and-tariffs`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Ошибка скачивания файла');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'insurance_and_tariffs.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (err) {
            alert('Ошибка скачивания: ' + err.message);
        }
    };

    return (
        <div className="user-mng-page">
            <header className="header">
                <NavBarAdmin />
            </header>

            <div className="profile-container">
                <h2>Импорт Excel страховых компаний</h2>
                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                    <input type="file" accept=".xlsx" onChange={handleUpload} disabled={uploading} />
                    <button onClick={handleDownload} style={{ background: 'green', color: 'white', padding: '5px 10px', cursor: 'pointer' }}>
                        📥 Скачать Excel
                    </button>
                </div>
                {uploading && <p>Загрузка...</p>}

                <h3>Фильтр</h3>
                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                    <input
                        type="text"
                        placeholder="Поиск по компании"
                        value={selectedCompany}
                        onChange={(e) => setSelectedCompany(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Поиск по тарифу"
                        value={selectedTariff}
                        onChange={(e) => setSelectedTariff(e.target.value)}
                    />
                    <button onClick={handleFilter}>🔍 Фильтровать</button>
                    <button onClick={handleResetFilter}>🔄 Сбросить</button>
                </div>

                <table className="history-table">
                    <thead>
                    <tr>
                        <th>ID компании</th>
                        <th>Название компании</th>
                        <th>Название тарифа</th>
                        <th>Цена тарифа</th>
                        <th>Описание тарифа</th> {/* ✅ новая колонка */}
                    </tr>
                    </thead>
                    <tbody>
                    {filteredInsurances.map((item, index) => (
                        <tr key={index}>
                            <td>{item.insuranceId}</td>
                            <td>{item.insuranceName}</td>
                            <td>{item.tariff.name}</td>
                            <td>{item.tariff.percent}%</td>
                            <td>{item.tariff.description}</td> {/* ✅ выводим description */}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default CompaniesManagementPage;
